import { gql } from 'apollo-angular';
import { addressGQL } from '@ui/legacy-lib';
import { paginationQuery } from '@ui/legacy-lib';

export const landlordFindPropertySearcherQuery = gql`
  query landlordFindPropertySearcher($searchTerm: String!) {
    landlordFindPropertySearcher(searchTerm: $searchTerm) {
      nodes {
        firstname
        name
        email
        userId
        portrait {
          title
          type
          url
          identifier
          name
          extension
          encrypted
          index
        }
        items {
          propertyId
          externalId
          name
          status
          score
          id
          rented
          portals {
            portal
            state
            credentials {
              name
            }
          }
          ${addressGQL}
          titleImage {
            title
            type
            url
            identifier
            name
            extension
            encrypted
            index
          }
        }
      }
      page {
        ${paginationQuery}
      }
    }
  }
`;
